<template>
  <div>

    <my-navBar></my-navBar>
    <my-buyTicStatus :curStatus='1'></my-buyTicStatus>
    <!-- 进入页面弹窗提示 -->
    <el-dialog center title="提示" :visible.sync="showToastModal" width="25%" top='30vh' custom-class="toastModal">
      <div class="toast">
        <div>您当前购买的是<span>{{ $store.state.selCineInfo.name }},
          </span><span>{{ $route.query.timeInfo.date + ' ' + $route.query.timeInfo.startHM + '-' +
            $route.query.timeInfo.endHM }}</span>场次，请仔细核对信息哦。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showToastModal = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 退票须知弹窗 -->
    <el-dialog title="退票须知" :visible.sync="showRefundModal" width="20%" custom-class='cineRuleCon'>
      <div class="dialog-content">
        <div>1.不支持退票</div>
        <div>2.不支持改签</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showRefundModal = false">确 定</el-button>
      </span>
    </el-dialog>

    <div class="box">
      <div class="left">
        <!-- 座位图 -->
        <seats :hallName='$store.state.selCineInfo.hall_name' :maxColumn='max_column' :seatList='seatList'
          :selSeatList='selSeatList' :totalPrice='totalPrice' :max_can_buy='max_can_buy' :isLeftToRight='isLeftToRight'
          @clickSeat='clickSeatCallBack'></seats>
      </div>
      <div class="right">
        <div class="mvInfo">
          <img :src="$route.query.mvInfo.cover" class="cover">
          <div class="mvName">{{ $route.query.mvInfo.name }}</div>
          <div class="mvInfoItem" v-if='$route.query.mvInfo.label'>
            <span class="title">类型：</span>
            <span>{{ $route.query.mvInfo.label }}</span>
          </div>
          <div class="mvInfoItem" v-if='$route.query.mvInfo.source'>
            <span class="title">地区：</span>
            <span>{{ $route.query.mvInfo.source }}</span>
          </div>
          <div class="mvInfoItem" v-if='$route.query.mvInfo.length'>
            <span class="title">片长：</span>
            <span>{{ $route.query.mvInfo.length }}分钟</span>
          </div>
        </div>
        <div class="cineInfo">
          <div class="cineInfoItem">
            <span class="title">影院：</span>
            <span class="cineName">{{ $store.state.selCineInfo.name }}</span>
          </div>
          <div class="cineInfoItem">
            <span class="title">影厅：</span>
            <span class="cineRoomName">{{ $store.state.selCineInfo.hall_name }}</span>
          </div>
          <div class="cineInfoItem">
            <span class="title">场次：</span>
            <span class="time">{{ $route.query.timeInfo.date + ' ' + $route.query.timeInfo.startHM + '-' +
              $route.query.timeInfo.endHM }}</span>
          </div>
          <div class="cineInfoItem">
            <span class="title seatTitle">座位：</span>
            <div class="selSeatListBox" v-if='selSeatList.length > 0'>
              <div class="selSeatItemBox" v-for='item in selSeatList' :key='item.seat_no'>
                <span class="selSeatItem">{{ item.name }}</span>
              </div>
              <div style="clear: both;"></div>
              <div class="seledToast">已选择<span>{{ selSeatList.length }}</span>个座位，再次点击座位可以取消
              </div>
            </div>
            <span class="noneSelSeat" v-if='selSeatList.length == 0'>还未选择座位</span>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="priceInfo">
          <div class="content">
            <div class="priceInfoOri">
              <span class="title">价格：</span>
              <span class="val">¥{{ minPrice }}起/座</span>
              <div class='allPrice'>
                合计：{{ totalPrice }}元
              </div>
            </div>
          </div>
          <el-button type="text" @click="showRefundModal = true">
            <div class="cinRules">
              <img src="@/assets/img/iconW.png">
              <span @click="showRefundModal = true">退票须知</span>
            </div>
          </el-button>
          <div class="confOrder" @click="confOrder">
            确认下单
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import seats from '@/components/seats.vue'
export default {
  name: 'selSeat',
  components: {
    seats
  },
  data() {
    return {
      max_can_buy: 4, //最大可购买座位数量（部分影院在请求中设置）
      max_column: 0,
      seatList: [], //座位列表
      isLeftToRight: true, //是否从左至右命名座位
      sugSeatList: [], //推荐座位列表
      selSeatList: [], //选中的座位列表信息
      totalPrice: '0.00', //总价
      showTimeSV: false, //tog显示更换场次列表？
      dateList: [], //更换场次列表

      showToastModal: false,
      showRefundModal: false,
      minPrice: 0,

    }
  },
  methods: {
    selSeat: function (seatRowIndex, seatItemIndex) {
      var curItem = this.seatList[seatRowIndex].seatLineItemArr[seatItemIndex];
      var clickCurClass = curItem.class;
      var clickCurType = curItem.type;
      var clickCurId = curItem.id;
      var clickCurSeatName = curItem.text;




      var selSeatList = this.selSeatInfo.selSeatList;
      //点击的不是可选座位
      if (clickCurClass != 'danren' && clickCurClass != 'vip' && clickCurClass != 'choosed') {
        return;
      }
      //已选4个&&不是取消座位
      if (selSeatList.length == 4 && (clickCurClass == 'danren' || clickCurClass == 'vip')) {
        return;
      }
      //改图标 && 控制右侧列表
      if (clickCurClass == 'danren' || clickCurClass == 'vip') {
        this.seatList[seatRowIndex].seatLineItemArr[seatItemIndex].class = 'choosed';
        //添加到右侧已选列表
        var seatItem = {
          id: clickCurId,
          name: clickCurSeatName
        }
        selSeatList.push(seatItem)
      } else if (clickCurClass == 'choosed') {
        this.seatList[seatRowIndex].seatLineItemArr[seatItemIndex].class = clickCurType;
        // 取消右侧座位
        for (var k = 0; k < selSeatList.length; k++) {
          if (selSeatList[k].id == clickCurId) {
            selSeatList.splice(k, 1);
          }
        }
      }
    },
    checkSeat: function () {
      var selSeatList = this.selSeatList;
      var isFail = false;
      //1个座位不用检查
      if (selSeatList.length <= 1) {
        isFail = false;
      } else {
        for (var i = 0; i < selSeatList.length; i++) {
          var hasNeighborSeat = false; //是否有相邻座位
          for (var n = 0; n < selSeatList.length; n++) {
            //同row && col相差1
            if (selSeatList[i].row_name == selSeatList[n].row_name && (Math.abs(selSeatList[i].column_name - selSeatList[n].column_name) == 1)) {
              hasNeighborSeat = true;
              break;
            }
            //同col && row相差1
            else if (selSeatList[i].column_name == selSeatList[n].column_name && (Math.abs(selSeatList[i].row_name - selSeatList[n].row_name) == 1)) {
              hasNeighborSeat = true;
              break;
            }
          }
          if (!hasNeighborSeat) {
            isFail = true;
            break;
          }
        }
      }
      return isFail;
    },
    confOrder: function () {
      var that = this;
      if (this.selSeatList.length == 0) {
        this.$message.error('请选择座位');
        return;
      }
      //恶意选座
      if (that.checkSeat()) {
        this.$alert('请选择相邻座位', '提示', {
          confirmButtonText: '确定',
        });
        return;
      }
      this.$router.push({
        path: '/ticConfirm',
        query: {
          mvInfo: JSON.stringify({
            cover: this.$route.query.mvInfo.cover,
            name: this.$route.query.mvInfo.name,
          }),
          timeInfo: JSON.stringify(this.$route.query.timeInfo),
          totalPrice: this.totalPrice,
          selSeatList: JSON.stringify(this.selSeatList),
          schedule_id: this.$route.query.schedule_id,
          plan_key: that.$route.query.plan_key,
          film_code: that.$route.query.film_code,
        }
      })
    },
    comp_areaPrice: function (price, seat_area = '') {
      var schedule_area = this.$route.query.schedule_area;
      // var price = this.$route.query.price;
      var seatPrice = price; //默认 =price
      //如果有区域价格
      if (schedule_area.length) {
        for (var i = 0; i < schedule_area.length; i++) {
          if (seat_area == schedule_area[i].areaId) {
            seatPrice = (Number(seatPrice) + Number(schedule_area[i].diffPrice)).toFixed(2)
            break;
          }
        }
      }
      return seatPrice;
    },
    getRowColNameVal: function (seatName) {
      var rowName = '';
      var colName = '';
      //不同影城系统，name的返回值不同：*：9排3座   *：9排3列
      var rowUnit = '排'
      if (seatName.indexOf('行') >= 0) {
        rowUnit = '行';
      }
      rowName = seatName.split(rowUnit)[0];

      var columnUnit = '座'
      if (seatName.indexOf('列') >= 0) {
        columnUnit = '列';
      }
      colName = seatName.split('排')[1].split(columnUnit)[0]; //有的影厅1排1座是在左边，有的是在右边
      return {
        rowName,
        colName
      };
    },
    fn_isLeftToRight: function (regular, seatList) {
      var seat0ColName = this.getRowColNameVal(seatList[0].name).colName;
      var seat1ColName = this.getRowColNameVal(seatList[1].name).colName;
      var isLeftToRight = true;
      //行列
      if (regular) {
        if (seatList[0].column > seatList[1].column && seat0ColName < seat1ColName) {
          isLeftToRight = false;
        }
      }
      //坐标
      else {
        if (seatList[0].left_px > seatList[1].left_px && seat0ColName < seat1ColName) {
          isLeftToRight = false;
        }
      }
      this.isLeftToRight = isLeftToRight;
    },
    axiosSeatList: function () {
      var that = this;
      that.axios.post('/resUrlTB/api/v2/getPlanSeats', {
        cinema_id: that.$store.state.selCineInfo.id,
        group_id: that.$store.state.group_id,
        city_name: that.$store.state.selCityInfo.region_name,
        plan_key: that.$route.query.plan_key,
      })
        .then((res) => {
          if (res.data.code == 0) {
            var result = res.data.content;
            var regular = true;
            var seatList = [];
            /*--
             *绘图方式是2选1，由影院系统决定。regular为true:行列定位绘图；  regular为false:坐标定位绘图
             *座位定位：（行列绘图）用row、column定位
             *座位定位：（坐标定位绘图）用top_px、left_px定位
             *座位名称：都必须用返回的row_name取‘排’的名字，text取‘列’的名字
             */
            var resSeatList = result.seats;
            var seatList = [];

            //判断座位是否从左至右命名，很关键作用于情侣座点击事件
            // that.fn_isLeftToRight(regular, resSeatList);

            //计算坐标定位最小值是0 还是 30
            if (!regular) {
              var minTopPx = Math.min.apply(Math, resSeatList.map(function (item) {
                return item.top_px
              }));
              var minLeftPx = Math.min.apply(Math, resSeatList.map(function (item) {
                return item.left_px
              }));
            }

            var max_column = 0;
            for (var i = 0; i < resSeatList.length; i++) {
              var trans_row = '';
              var trans_column = '';

              /*--行列定位绘图--*/
              if (regular) {
                // trans_row = resSeatList[i].row - 1;
                // trans_column = resSeatList[i].column - 1;
                // max_column = result.max_column;
                max_column = Number(resSeatList[i].graph_col) + 1 > max_column ? Number(resSeatList[i].graph_col) + 1 : max_column; //graph_col从0开始的
                trans_row = resSeatList[i].graph_row;
                trans_column = resSeatList[i].graph_col;
              }
              /*--坐标定位绘图--*/
              else {
                /*从0开始，从30开始*/
                //minTopPx
                if (minTopPx == 0) {
                  trans_row = (resSeatList[i].top_px / 30);
                } else {
                  trans_row = (resSeatList[i].top_px / 30) - 1;
                }
                //minLeftPx
                if (minLeftPx == 0) {
                  trans_column = (resSeatList[i].left_px / 30);
                  max_column = (result.max_left_px / 30) + 1;
                } else {
                  trans_column = (resSeatList[i].left_px / 30) - 1;
                  max_column = result.max_left_px / 30;
                }
              }
              //new一个colItem
              var colItem = {
                // id: resSeatList[i].ext_id,
                // row: trans_row,
                // column: trans_column,
                // area: resSeatList[i].area,
                // name: resSeatList[i].name, // 几排几座
                // class: 'selled', //默认已售图标
                // price: that.comp_areaPrice(resSeatList[i].area),
                // flag: resSeatList[i].flag
                id: resSeatList[i].area_id,
                row: trans_row,
                column: trans_column,
                name: resSeatList[i].seat_row + "排" + resSeatList[i].seat_col + "座", // 几排几座
                class: 'selled', //默认已售图标
                price: that.comp_areaPrice(that.$route.query.price, resSeatList[i].area_id), //默认价
                commonPrice: that.$route.query.commonPrice > 0 ? that.comp_areaPrice(that.$route.query.commonPrice, resSeatList[i].area_id) : 0, //普通购价
                artificial_buy_price: that.$route.query.artificial_buy_price > 0 ? that.comp_areaPrice(that.$route.query.artificial_buy_price, resSeatList[i].area_id) : 0, //优惠购价
                flag: resSeatList[i].seat_type,
                seat_no: resSeatList[i].seat_no,
                row_name: resSeatList[i].seat_row, //判断恶意选座用的 座位行
                column_name: resSeatList[i].seat_col, //判断恶意选座用的 座位列
                seats: resSeatList[i],
                seat_state: resSeatList[i].seat_state
              }
              //不同影城系统，name的返回值不同：*：9排3座   *：9排3列
              // var rowColName = that.getRowColNameVal(resSeatList[i].name);
              // colItem.row_name = rowColName.rowName;
              // colItem.column_name = rowColName.colName;

              if (resSeatList[i].seat_state == 0) { //0是可售
                //单人
                if (resSeatList[i].seat_type == 'N') { //N是普通座位
                  colItem.class = 'canBuy'
                }
                //情侣
                else {
                  if (resSeatList[i].seat_type == 'L') { //情侣座左
                    colItem.class = 'couple_left'
                  } else if (resSeatList[i].seat_type == 'R') { //情侣座右
                    colItem.class = 'couple_right'
                  }
                }
              }
              //已售(默认是单人已售，当座位是情侣时)
              else {
                if (resSeatList[i].seat_type == 'L') {
                  colItem.class = 'selled_coupleLeft';
                } else if (resSeatList[i].seat_type == 'R') {
                  colItem.class = 'selled_coupleRight';
                }
              }

              /*---该row未创建---*/
              if (!seatList[trans_row]) {
                //new一个row
                seatList[trans_row] = {
                  row: trans_row, // 绘图显示的第几排（留着可以绘画出过道的效果）   
                  row_name: "", //文字显示的第几排，假设第4排是过道，但此时resSeatList[i].row是5，但用户看到的应该是4（row_name）
                  columnItems: []
                };
              }
              //将colItem赋值给row(这时row都是已创建状态了)
              seatList[trans_row].columnItems[trans_column] = colItem;
            }

            seatList.forEach(item => {
              let show = item.columnItems.some(i => i.id)
              item.columnItems.forEach(q => {
                if (q && q.row_name) {
                  item.row_name = q.row_name
                }
              })
              console.log(show);
              item["show"] = show
            })

            that.seatList = seatList;
            that.max_can_buy = result.max_can_buy || that.max_can_buy;
            that.max_column = max_column;

          } else {
            if (res.data.code != 50003 || res.data.code != 40004 || res.data.code != 48001) {
              that.$alert(res.data.message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  that.$router.go(-1);
                }
              });

            }
          }
        })
    },
    clickSeatCallBack: function (e) {
      var copy_clickSeatItem = e.copy_clickSeatItem;
      var rowIndex = copy_clickSeatItem.row;
      var colIndex = copy_clickSeatItem.column;

      this.$set(this.seatList[rowIndex].columnItems, colIndex, copy_clickSeatItem);
      this.selSeatList = e.selSeatList;
      this.totalPrice = e.totalPrice;

    },
  },

  created: function () {
    this.$route.query.mvInfo = JSON.parse(this.$route.query.mvInfo);
    this.$route.query.timeInfo = JSON.parse(this.$route.query.timeInfo);
    this.minPrice = this.global.getMinAreaPrice(this.$route.query.price, this.$route.query.schedule_area).price;
    //清空idCards
    this.$store.commit('updateIdCards', []);
    //获取座位
    this.axiosSeatList();
  },
}
</script>

<style scoped src='@/assets/css/selSeat.css'></style>

<style scoped src='@/assets/css/seat_icon.css'></style>
